import styled from "@emotion/styled";

export const Wrapper = styled.div`
  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: flex;
    align-items: center;
  }
`;

export const ProgressBarWrapper = styled.div`
  margin-top: ${p => p.theme.space[6]}px;
`;

export const ProgressText = styled.p`
  margin-bottom: ${p => p.theme.space[4]}px;

  color: ${p => p.theme.colors.secondary.gray};
  font-size: ${p => p.theme.fontSizes.m};
  font-weight: ${p => p.theme.fontWeight.medium};
  line-height: normal;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[6]}px;

    color: ${p => p.theme.colors.black};
    font-size: 22px;
    font-weight: ${p => p.theme.fontWeight.semiBold};
    line-height: 1.25;
  }
`;

export const ButtonWrapper = styled.div`
  min-width: 127px;

  margin-top: ${p => p.theme.space[4]}px;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    margin-left: ${p => p.theme.space[4]}px;
    margin-top: ${p => p.theme.space[0]};
  }
`;

export const InputWrapper = styled.div`
  flex-grow: 1;
`;

export const ResultWrapper = styled.div`
  padding: ${p => p.theme.space[5]}px;
  border-radius: ${p => p.theme.radii.medium};
  background-color: ${p => p.theme.colors.background};
`;

export const ResultText = styled.p`
  font-size: ${p => p.theme.fontSizes.m};
  line-height: 1.78;
  white-space: pre-wrap;
  color: ${p => p.theme.colors.secondary.gray};
`;
